import { getAccentColor } from '../lib/jlfcTheme';

export function getJlfcModalProps() {
  const c = getAccentColor();
  return {
    withCloseButton: false,
    closeOnClickOutside: false,
    closeOnEscape: false,
    styles: {
      header: {
        backgroundColor: `var(--mantine-color-${c}-0)`,
        borderBottom: `1px solid var(--mantine-color-${c}-2)`,
        paddingTop: 10,
        paddingBottom: 10,
        minHeight: 'auto',
      },
      title: {
        fontSize: 'var(--mantine-font-size-md)',
        fontWeight: 600,
        lineHeight: 1.25,
        color: `var(--mantine-color-${c}-9)`,
      },
      body: {
        paddingTop: 'var(--mantine-spacing-md)',
        paddingBottom: 'var(--mantine-spacing-md)',
      },
    },
  };
}

/** @deprecated utiliser getJlfcModalProps() */
export const jlfcModalProps = getJlfcModalProps();

export function blockModalEnterKey(e) {
  if (e.key !== 'Enter') return;
  const tag = e.target?.tagName?.toLowerCase();
  if (tag === 'textarea') return;
  e.preventDefault();
}

/** Modales formulaires verticales (engins, libellés longs). */
export const JLFC_WIDE_MODAL_SIZE = 'min(680px, 94vw)';

/** Modales détail (règlement, facture…) avec tableaux imbriqués. */
export const JLFC_DETAIL_MODAL_SIZE = 'min(920px, 96vw)';

/** Modales empilées (zoom fichier au-dessus d'une autre modale). */
export const JLFC_NESTED_MODAL_ZINDEX = 400;


const SELECT_LONG_LABEL_PROPS = {
  comboboxProps: { width: 'target', withinPortal: true },
  styles: {
    option: { whiteSpace: 'normal', wordBreak: 'break-word' },
  },
};

export { SELECT_LONG_LABEL_PROPS };
